// extracted by mini-css-extract-plugin
export var address = "contact-module--address--YTfAQ";
export var baton = "contact-module--baton--f-lMZ";
export var different = "contact-module--different--aTvB9";
export var gap = "contact-module--gap--EeHyp";
export var group = "contact-module--group--gor0M";
export var icons = "contact-module--icons--D7Tq8";
export var link = "contact-module--link--ohaxI";
export var special = "contact-module--special--sJiu1";
export var wrapper = "contact-module--wrapper--D2QDr";